export default "__VITE_ASSET__7169c553__"